type Option = Readonly<{ disabled?: boolean }>;

/** Whether a multi-select offers Select All: only once two or more of its options can be picked. */
export function canSelectAll(options: ReadonlyArray<Option>): boolean {
  let pickable = 0;
  for (const option of options) {
    if (option.disabled === true) continue;
    pickable += 1;
    if (pickable >= 2) return true;
  }
  return false;
}
